import { render, staticRenderFns } from "./EmpPropsForm.vue?vue&type=template&id=5012fa08&"
import script from "./EmpPropsForm.vue?vue&type=script&lang=js&"
export * from "./EmpPropsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports